export default __webpack_public_path__ + "img/icon-list.ad9e4abc.svg";